import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const shareDialogStore = new Vuex.Store({
  state: {
    title: '',
    desc:'',
    keys:''
  },
  mutations: {
    setNewTitleSearch (state,value) {
        state.title = value;
    },
    setNewDescSearch (state,value) {
        state.desc = value;
    },
    setNewKeysSearch (state,value) {
        state.keys = value;
    }
  }
})
